var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusIcon = function SvgPlusIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4167 10.8333H13.1667V5.58333C13.1667 5.26104 12.9056 5 12.5833 5H11.4167C11.0944 5 10.8333 5.26104 10.8333 5.58333V10.8333H5.58333C5.26104 10.8333 5 11.0944 5 11.4167V12.5833C5 12.9056 5.26104 13.1667 5.58333 13.1667H10.8333V18.4167C10.8333 18.739 11.0944 19 11.4167 19H12.5833C12.9056 19 13.1667 18.739 13.1667 18.4167V13.1667H18.4167C18.739 13.1667 19 12.9056 19 12.5833V11.4167C19 11.0944 18.739 10.8333 18.4167 10.8333Z",
    fill: "#028BB7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-icon.0593440c.svg";
export { ForwardRef as ReactComponent };